
const digest = '16bfa5c6a35ec583c643a24406cbaa9033abde1d9ddc7829c66b28b640702604';
const classes = {"wrapper":"_wrapper_oe21b_1","item":"_item_oe21b_12","active":"_active_oe21b_18"};
const css = `._wrapper_oe21b_1 {
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: #eaedf3;
  height: 100%;
  gap: 5px;
  border-radius: 5px;
  max-width: 400px;
  min-width: 400px;
}
._wrapper_oe21b_1 ._item_oe21b_12 {
  padding: 6px;
  font-weight: 500;
  font-size: 14px;
  border-radius: 5px;
}
._wrapper_oe21b_1 ._item_oe21b_12._active_oe21b_18 {
  background-color: #1d65d8;
  color: #fff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  